<template>
  <div v-if="this.showgraph()" class="charts">
    <v-card elevation="5" class="ma-3 futureloadcontainer" min-width="1000">
      <v-tabs v-model="$store.state.graphs.graphTab" background-color="#F7F7F7" fixed-tabs>
        <v-tab v-if="this.showaverageload()" href="#tab-2" @click="setActiveTab"> Average Load</v-tab>
        <v-tab href="#tab-1" @click="setActiveTab"> Future Load </v-tab>
        <v-tab href="#tab-3" @click="setActiveTab"> Historical Load</v-tab>
        <v-tab href="#tab-4" @click="setActiveTab"> Available Work</v-tab>
        <v-tab v-if="this.showaverageload()" href="#tab-5" @click="setActiveTab"> Flow Animation</v-tab>
      </v-tabs>

      <div class="graph-container">
        <v-tabs-items height="100%" v-model="$store.state.graphs.graphTab">
          <v-tab-item height="100%" :value="'tab-1'">
            <FutureLoadGraph  ref="futureLoad" id="0"/>
          </v-tab-item>
          <v-tab-item :value="'tab-2'">
            <AverageLoadGraph  ref="average" id="1"/>
          </v-tab-item>
          <v-tab-item :value="'tab-3'">
            <HistoricalLoad  ref="historic" id="2"/>
          </v-tab-item>
          <v-tab-item :value="'tab-4'">
            <WaitingTimeGraph  ref="waitingTime" id="3"/>
          </v-tab-item>
          <v-tab-item :value="'tab-5'">
            <WaitingTimeAnimation  ref="waitingTimeAnimation" id="4"/>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-card>
  </div>
  <div class="noGraphs" v-else>
    <div v-if="this.$store.state.simulator == null" class="nographText">No simulation is loaded, go to the pipeline page first</div>
    <div v-else class="nographText">This simulation does not support graphs for educative reasons</div>
  </div>
</template>

<script>
import * as d3 from "d3";
import FutureLoadGraph from "@/components/graphs/FutureLoadGraph.vue";
import AverageLoadGraph from "@/components/graphs/AverageLoadGraph.vue";
import HistoricalLoad from "@/components/graphs/HistoricalLoad.vue";
import WaitingTimeGraph from "@/components/graphs/WaitingTimeGraph.vue";
import WaitingTimeAnimation from "@/components/graphs/WaitingTimeAnimation.vue";

export default {
  name: "LineChart",
  components: {WaitingTimeAnimation, WaitingTimeGraph, FutureLoadGraph, AverageLoadGraph, HistoricalLoad},
  data: () => ({
    transform: null,
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    selection: null,
    resizeFunctions: [],
    selectAll: true,
    colorMapper: { B: "#00A1FF", O: "#FEAE00", I: "#004D80", M: "#A33D32", A: "#16E7CF", P: "#FF42A1" },
    focusPaths: {},
    contextPaths: {},
    updateDomain: null,
    loading: true,
  }),

  methods: {
    setActiveTab(item) {
     
    },
    showaverageload(){
      if(this.$store.state.simulator == null){
        return false;
      }
      
      return !this.$store.state.simulator.params.allowPortfolioPlanning;
    },
    showgraph() {

      if(this.$store.state.simulator == null){
        return false;
      }

      return this.$store.state.simulator.params.showGraphs;
    },
  },
  mounted() {
 
  },
};
</script>

<style scoped>
.graph-container {
  width: 100%;
  height: calc(100% - 48px);
}

.v-window__container,
.v-window-item {
  height: 100%;
}

.v-window {
  height: 100%;
}
.v-window__container {
  height: 100%;
}

.charts {
  overflow: auto;
  height: 100%;
}

.futureloadcontainer {
  height: 900px;
  min-height: 500px;
  width: calc(100% - 24px);
  margin-top: 100px;
  position: absolute;
}

.noGraphs {
  width: 100%;
  height: 100%;
  padding: 50px;
  display: flex;
  font-size: 2em;
  font-family: Helvetica, sans-serif;
  font-weight: bold;
  position: absolute;
}

.nographText {
  width: 100%;
  height: 100%;
  text-align: center;
}
</style>
